import { computed, ref, unref } from 'vue';

const initial = {
  current: 0
};

const zIndex = ref(0);

export const defaultInitialZIndex = 10;

export const useZIndex = zIndexOverrides => {
  const initialZIndex = computed(() => {
    const zIndexFromParent = unref(zIndexOverrides);
    return typeof zIndexFromParent === 'number'
      ? zIndexFromParent
      : defaultInitialZIndex;
  });

  const currentZIndex = computed(() => initialZIndex.value + zIndex.value);

  const nextZIndex = () => {
    // eslint-disable-next-line no-plusplus
    initial.current++;
    zIndex.value = initial.current;
    return currentZIndex.value;
  };

  return {
    nextZIndex
  };
};
